import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationItemKinds = {
  MESSAGE: 'message',
  ENVELOPE: 'envelope',
  ERROR: 'error',
} as const

export type ConversationItemKindEnum = Enum<typeof ConversationItemKinds>
